import React from 'react';
import { Grid } from '@mui/material';
import DefaultSelectClient from '../../../components/default-select-client';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { FilterInput, FilterSelect } from '../../../components/filter-fields';
import { GridPanel } from '../../../components/list-grid-panel';
import PurchaseDataTable from './components/purchase-data-table';
import { usePurchaseSearchController } from './context/purchase-search-controller';
import { usePurchaseSearchState } from './context/purchase-search-context';
import { toLookupOptions } from '../shared/lookup-select';
import { buildSortOptions, toSortValue } from '../shared/scp-utils';
import { PurchaseSortField } from '../../../model/scp/purchase/purchase-sort-field';

const PURCHASE_SORT_OPTIONS = buildSortOptions([
    { field: PurchaseSortField.UpdatedDate, label: 'Data de Alteração' },
    { field: PurchaseSortField.CreatedDate, label: 'Data de Criação' },
    { field: PurchaseSortField.Number, label: 'Número' },
    { field: PurchaseSortField.NumberProcess, label: 'Nº Processo' },
    { field: PurchaseSortField.Year, label: 'Exercício' },
    { field: PurchaseSortField.Title, label: 'Título' },
    { field: PurchaseSortField.Object, label: 'Objeto' },
    { field: PurchaseSortField.Modality, label: 'Modalidade' },
    { field: PurchaseSortField.DisputeMode, label: 'Modo de Disputa' },
    { field: PurchaseSortField.Situation, label: 'Situação' },
]);

export function PurchaseSearchComponent() {
    const ctrl = usePurchaseSearchController();
    const { modality, situation, disputeMode, parameters, searchTrigger } = usePurchaseSearchState();

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Compras e Licitações"
                    subtitle="Pesquise e gerencie os processos de aquisição e licitações"
                    breadcrumbs={[{ label: 'Compras e Licitações' }]}
                />
            </Grid>

            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={6}>
                        <FilterInput label="Buscar por" name="input-term" value={parameters.term} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <FilterSelect label="Ordenar por" name="select-sort" value={toSortValue(parameters.sortBy, parameters.sortDirection)} options={PURCHASE_SORT_OPTIONS} onChange={ctrl.handleOnChange} emptyLabel="Padrão" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <FilterInput label="Exercício" name="input-year" type="number" value={parameters.year} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FilterSelect label="Situação" name="select-situation" value={parameters.situationId} options={toLookupOptions(situation)} onChange={ctrl.handleOnChange} emptyLabel="Todas" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FilterSelect label="Modalidade" name="select-modality" value={parameters.modalityId} options={toLookupOptions(modality)} onChange={ctrl.handleOnChange} emptyLabel="Todas" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FilterSelect label="Modo de Disputa" name="select-dispute-mode" value={parameters.dispupteModeId} options={toLookupOptions(disputeMode)} onChange={ctrl.handleOnChange} emptyLabel="Todos" />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DefaultSelectClient required={false} clientId={parameters.clientId} handleOnChange={ctrl.handleOnChange} />
                    </Grid>
                </FilterPanel>
            </Grid>

            <Grid item xs={12}>
                <GridPanel addLabel="Nova compra ou licitação" onAdd={ctrl.navigateToCreate}>
                    <PurchaseDataTable
                        parameters={parameters}
                        searchTrigger={searchTrigger}
                        onPaginationChange={ctrl.handlePaginationChange}
                        onEdit={ctrl.navigateToEdit}
                        onDelete={ctrl.handleDelete}
                    />
                </GridPanel>
            </Grid>
        </React.Fragment>
    );
}
